//Constants
import { details } from '../../../constants/cursos'

function AreasCientificas({ areas, lang }) {
  return (
    <article className='bg-color py-5'>
        <div className="container page">
            <div className="row">
                <div className="col-md-2">
                <p className='course-title-detail'><strong>{details.areas[lang]}</strong></p>
                </div>
                <div className="col-md-1"></div>
                <div className="col-md-9">
                    <div className="position-relative">
                        <table className='areas-cientificas-detail'>
                            <caption class="sr-only" style={{color: '#f1f1f1'}}>Áreas Científicas</caption>
                            <thead>
                                <tr>
                                    <th><strong>{details.headerAreas.area[lang]}</strong></th>
                                    <th style={{textAlign:"center"}}><strong>{details.headerAreas.sigla[lang]}</strong></th>
                                    <th style={{textAlign:"center"}}><strong>{details.headerAreas.ectsOb[lang]}</strong></th>
                                    <th style={{textAlign:"center"}}><strong>{details.headerAreas.ectsOp[lang]}</strong></th>
                                </tr>
                            </thead>
                            <tbody>
                                {areas.map((area, index) => (
                                    <tr key={index}>
                                        <td>{area.$.nome}</td>
                                        <td style={{textAlign:"center"}}>{area.$.sigla}</td>
                                        <td style={{textAlign:"center"}}>{area.$.obrigatorios}</td>
                                        <td style={{textAlign:"center"}}>{area.$.opcionais}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>                                        
                </div>
            </div>
        </div>
    </article>
  )
}

export default AreasCientificas